// extracted by mini-css-extract-plugin
export default {"fileInfo":"fileInfo___m5Zgx","card":"card___qem77","img":"img___p7ziN","info":"info___sLa7e","infoSize":"infoSize___l8vGQ","Progress":"Progress___c0UHC"};